// Lecture guidée : les coordonnées restent fixes ; seuls les repères et la distance sont mis en évidence.
export function mountPlaceMap(container, { point, stop, address, seen, distance, onPhase }) {
  const L = window.L;
  if (!L || !container) { onPhase("unavailable"); return null; }
  const map = L.map(container, { zoomControl: true, scrollWheelZoom: false });
  map.attributionControl.setPrefix(false);
  ["World_Imagery", "Reference/World_Transportation", "Reference/World_Boundaries_and_Places"].forEach((layer, at) =>
    L.tileLayer(`https://server.arcgisonline.com/ArcGIS/rest/services/${layer}/MapServer/tile/{z}/{y}/{x}`,
      { maxZoom: 19, attribution: at ? "" : "Esri", className: "gg-place-tiles" }).addTo(map));
  const media = window.matchMedia("(prefers-reduced-motion: reduce)");
  let timers = [];
  const phase = (value) => { container.dataset.phase = value; onPhase(value); };
  const clear = () => { timers.forEach(clearTimeout); timers = []; };
  const label = (text) => { const node = document.createElement("span"); node.textContent = text; return node; };
  const labels = [];
  const west = point[1] <= stop[1];
  const pin = (at, color, key, text, direction) => {
    L.circleMarker(at, { radius: 18, color, weight: 2, fillOpacity: 0, interactive: false, className: `gg-place-halo gg-place-halo-${key}` }).addTo(map);
    const marker = L.circleMarker(at, { radius: 8, color: "#fff", weight: 2, fillColor: color, fillOpacity: 1, className: `gg-place-pin-${key}` })
      .bindTooltip(label(text), { permanent: true, direction, offset: [direction === "left" ? -8 : 8, 0],
        className: `geotab-place-label gg-place-label-${key}` }).addTo(map);
    labels.push({ marker, direction });
  };
  L.circle(point, { radius: 1000, color: "#2563eb", weight: 1, dashArray: "4 4", fillOpacity: 0.035 }).addTo(map);
  if (distance) {
    L.polyline([point, stop], { color: "#fff", weight: 2, className: "gg-place-distance" })
      .bindTooltip(label(distance), { permanent: true, direction: "center", className: "geotab-place-label gg-place-label-distance" }).addTo(map);
  }
  pin(point, "#2563eb", "blue", address, west ? "left" : "right");
  pin(stop, "#dc3f38", "red", seen, west ? "right" : "left");
  const fit = () => {
    map.invalidateSize();
    const x = Math.min(230, Math.max(85, container.clientWidth * 0.23));
    map.fitBounds(L.latLngBounds([point, stop]), { paddingTopLeft: [x, 60], paddingBottomRight: [x, 60], maxZoom: 16, animate: false });
    labels.forEach(({ marker, direction }) => {
      const tooltip = marker.getTooltip();
      tooltip.options.direction = container.clientWidth < 640 ? "top" : direction;
      tooltip.options.offset = container.clientWidth < 640 ? [0, -9] : [direction === "left" ? -8 : 8, 0];
      tooltip.update();
    });
  };
  const observer = new ResizeObserver(fit);
  observer.observe(container);
  fit();
  const replay = () => {
    clear();
    if (media.matches) { phase("done"); return; }
    phase("ready");
    [[450, "blue"], [1750, "red"], [3050, "distance"], [4250, "done"]].forEach(([delay, value]) => {
      timers.push(setTimeout(() => phase(value), delay));
    });
  };
  const onMotion = () => { if (media.matches) { clear(); phase("done"); } };
  media.addEventListener("change", onMotion);
  return { replay, destroy() { clear(); observer.disconnect(); media.removeEventListener("change", onMotion); map.remove(); } };
}
